import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M144.3 32.04c-37.4-.75-80.6 9.4-125.7 29.25C7.18 66.316 0 77.96 0 90.44v357.6c0 11.55 11.99 19.55 22.45 14.65 126.3-59.14 219.8 11 223.8 14.01 2.85 2.2 6.25 3.3 9.75 3.3 12.4 0 16-11.38 16-15.98V80.04c0-5.203-2.531-10.08-6.781-13.08C263.3 65.58 216.7 33.35 144.3 32.04",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M557.4 61.29c-45.11-19.79-88.48-29.61-125.7-29.26-72.44 1.312-118.1 33.55-120.9 34.92-4.3 3.01-6.8 7.88-6.8 13.09v383.1c0 5.26 3.5 16.86 16 16.86 3.484 0 6.938-1.125 9.781-3.328 3.925-3.018 97.44-73.16 223.8-14 10.46 4.896 22.45-3.105 22.45-14.65v-357.6C575.1 77.97 568.8 66.31 557.4 61.29",
      style: {"fill":"var(--fa-secondary-color, currentColor)","opacity":"var(--fa-secondary-opacity, 0.4)"}
    }, null, -1)
  ])))
}
export default { render: render }